import { render, staticRenderFns } from "./UserTrainingCourseDelete.vue?vue&type=template&id=6e014778&"
import script from "./UserTrainingCourseDelete.vue?vue&type=script&lang=js&"
export * from "./UserTrainingCourseDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports